export const blockIconsActivitiesDownhillSkiingNew = (
	<span className='material-symbols-outlined'>downhill_skiing</span>
);
